// removed by extract-text-webpack-plugin
module.exports = {"container":"C_E29wQF_SlgZU3rhha6W"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Templates/Layout/styles.css
// module id = 2959
// module chunks = 0